import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import './global.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// NOTE: StrictMode is intentionally NOT used — ReactKeycloakProvider calls
// keycloak.init() on mount and Keycloak instances can only be initialized once
// (double-mount in StrictMode dev crashes with "can only be initialized once").
// This matches the proven TePresta frontend pattern.

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element #root not found');
}

createRoot(root).render(<App />);
